export const DisplayControlGroupTranslationJP = {
  DisplayControlGroup: {
    Title: '表示制御グループ一覧',
    Headers: {
      Title: '表示制御グループ詳細',
      Desc: '※表示名は、日本語以外の言語を選択し、その言語が未設定の場合、英語が表示されます。',
    },
    Filter: {
      name: '名称',
      delete_date: '削除データ',
      hide_del: '削除データ非表示',
      show_all_del: '削除データ含めて表示',
      show_del: '削除データのみ表示',
    },
    Button: {
      select_all: '全選択',
      cancel_all: '解除',
      reload: 'リロード',
      detail: '詳細',
      delete: '削除',
      search: '絞り込み',
      add_new: '新規追加',
      keep: '保存',
      preview: 'プレビュー',
      restore: '復元',
      display_control_group: '制御メニュー設定',
    },
    Table: {
      selection: '選択',
      code: 'コード',
      name: '表示制御グループ名',
      note: '備考',
      action: '制御メニュー',
    },
    Form: {
      name: '表示制御グループ名',
      change: '変更',
      display_name: '表示名',
      display_name_ja: '日本語',
      display_name_en: '英語',
      display_name_zh_hans: '中国語(簡体字)',
      display_name_zh_hant: '中国語(繫体字)',
      display_name_ko: '韓国語',
      display_name_vi: 'ベトナム語',
      note: '備考',
    },
    Validator: {
      name: '名前が必要',
      500: '500 error server',
      success: '成功',
      error: '失敗',
      delete_success: '削除しました',
      add_success: '保存しました',
      restore_success: '復元しました。',
    },
    ModalControlGroup: {
      Title: '表示制御グループ対象メニュー設定',
      Group: '表示制御グループ：',
      TableLeft: {
        Title: '〇表示条件メニュー一覧',
        Desc: '表示制限のきっかけとなるメニューを設定します。',
        Btn_Del: '削除',
        Btn_Add: '追加',
        selection: '選択',
        code: 'メニューコード',
        name: 'メニュー名',
      },
      TableRight: {
        Title: '〇表示タイミング制御メニュー一覧',
        Desc: '注文後、メニューボタンがアクティブになるメニューを設定します。',
        Btn_Del: '削除',
        Btn_Add: '追加',
        selection: '選択',
        code: 'メニューコード',
        name: 'メニュー名',
      },
      TableCenter: {
        Desc: '左のメニューを注文する<br />と、右のメニューを注文で<br />きるようになります。',
      },
    },
    Confirm: {
      Delete_Restriction: '選択された表示条件メニューを削除します。よろしいですか？',
      Delete_Activations:
        '選択された表示タイミング制御メニューをリストから削除します。削除したメニューは詳細の表示タイミングを変更します。よろしいですか？',
      Delete_Control_Group: '選択された表示制御グループを削除します。よろしいですか？',
      Delete_Control_Group_Already_Exit:
        '選択された表示制御グループのうち（{{message}}）は、制御メニューが存在しているため削除できません。制御メニューを削除してから表示制御グループを削除してください。それ以外の選択された表示制御グループを削除します。よろしいですか？',
    },
  },
};
